<!--
 * @Author: wh
 * @Date: 2020-07-01 17:05:02
 * @LastEditTime: 2022-02-07 17:52:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JT_Mobile_test\src\views\salesTerminal\orderSituation\orderList\index.vue
-->
<template>
    <div class="commonTableStyles orderSituationList">
        <van-nav-bar
            :title="isLeader?'生产订单':'订单进度'"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        >
            <van-icon
                class="iconfont iconshaixuan"
                slot="right"
                @click="showPopup('screen')"
            ></van-icon>
        </van-nav-bar>
        <div class="search-con">
            <van-search
                placeholder="请输入搜索关键词"
                v-model="keywords"
                @search="handleSearch"
            ></van-search>
        </div>
        <div class="count-box">
            <div class="title">
                {{ station_name }}
            </div>
            <div class="count-item">
                <div class="item">
                    任务方量(m³)：<label>{{ quantityTotal }}</label>
                </div>
                <div class="item item2">
                    完成方量(m³)：<label>{{ volumeTotal }}</label>
                </div>
            </div>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh" pull-distance="110">
            <template>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <ul class="list">
                            <template v-for="(item,index) in orderList">
                                <li :key="`orderList_${index}`">
                                    <div class="engineeringInfo">
                                        <h4 class="engineeringInfo_header">
                                            <span :class="['state', 'status'+item.status]">
                                                {{ item.status_name }}
                                            </span>
                                            <span class="headerName">订单编号：{{ item.order_number }}</span>
                                        </h4>
                                        <div class="engineeringInfo_content">
                                            <p>
                                                <span class="info">客户名称：{{ item.customer_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">工程名称：{{ item.project_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">施工单位：{{ item.sgdw_name }}</span>
                                            </p>
                                            <p>
                                                <span class="info">施工部位：{{ item.place_detail }}</span>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <span class="info">供货站点：{{ item.station_name }}</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <span class="info">
                                                            标号：{{ item.strength_grade_name+' '+(item.special_require_name||'') }}
                                                        </span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <span class="info">计划方量：{{ item.quantity }}m³</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <span class="info">发货方量：{{ item.grand_total_quantity }}m³</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <van-row>
                                                    <van-col span="12">
                                                        <span class="info">发货车次：{{ item.grand_total_vehicle }}次</span>
                                                    </van-col>
                                                    <van-col span="12">
                                                        <span class="info">签收方量：{{ item.sign_volume }}m³</span>
                                                    </van-col>
                                                </van-row>
                                            </p>
                                            <p>
                                                <span class="info">开始供应时间：{{ item.product_time||'未开始供应' }}</span>
                                            </p>
                                        </div>
                                        <div class="btn-con">
                                            <div class="btn-item" @click="toTransOrder(item.order_number)">
                                                <span class="btn-span">查看明细</span>
                                            </div>
                                            <div class="btn-item" @click="toTransMap(item.order_number)">
                                                <span class="btn-span">发货进度</span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </van-list>
                </div>
            </template>
        </van-pull-refresh>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
        <van-popup
            class="sideslip"
            v-model="popupShow"
            position="right"
            :style="{ width: '80%',height: '100%' }"
        >
            <div class="screen">
                <van-nav-bar
                    title="筛选"
                    right-text="取消"
                    @click-right="popupShow=false"
                >
                </van-nav-bar>
                <section>
                    <div class="item">
                        <div class="title">
                            状态
                        </div>
                        <ul>
                            <li
                                :class="{active:item.val === selectStatus}"
                                v-for="item in statusLs"
                                :key="item.val"
                                @click="handleSelectStatus(item)"
                            >
                                {{ item.label }}
                            </li>
                        </ul>
                        <div class="title" v-show="stationLs.length>0">
                            场站
                        </div>
                        <ul>
                            <li
                                :class="{active:item.station_id === selectStationCode}"
                                v-for="item in stationLs"
                                :key="item.station_id"
                                @click="handleSelectStation(item)"
                            >
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                </section>
                <footer>
                    <button @click="confirmSelect">
                        确定
                    </button>
                    <button @click="resetSelect">
                        重置
                    </button>
                </footer>
            </div>
        </van-popup>
    </div>
</template>
<script>
import BLL from './index';
export default {
    name: 'order-situation-list',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'order-situation-list');
        }
        next();
    },
    data() {
        return {

            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 6,
            },
            total: true,
            cvid: '',
            // 下拉刷新
            isLoading: false,
            // 关键词
            keywords: '',
            // 加载层
            showOverlay: false,
            isLeader: false,

            // 筛选侧滑菜单状态
            popupShow: false,
            statusLs: [
                { label: '全部', val: -1 },
                { label: '待生产', val: 1 },
                { label: '生产中', val: 2 },
                { label: '已完成', val: 3 },
                { label: '暂停', val: 4 },
            ],
            // 场站列表
            stationLs: [{ station_id: '', name: '全部' }],
            // 筛选临时选择状态
            selectStatus: '',
            // 筛选临时选择场站
            selectStationCode: '',
            selectStationName: '',
            // 当前状态
            status: '',
            // 当前场站编码
            station_code: '',
            station_name: '全部',
            // 任务方量统计
            quantityTotal: 0,
            // 发货方量统计
            volumeTotal: 0,
        };
    },
    activated() {

    },
    created() {
        // this.page.pageindex = 1;
        // this.retailList = [];
        // this.finished = false;
        // this.showOverlay = true;
        // this.keywords = '';
        // 初始化
        this.BLL = new BLL(this);
        // this.orderListPage();
        // 是否是领导端
        this.isLeader = this.$route.query.leader;
        this.getStationData();
        this.getStatisData();
    },
    methods: {

        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
            this.$router.go(-1);
        },
        // 查看明细
        toTransOrder(order_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'transOrderlist', params: { order_number: order_number } });
        },
        // 发货进度
        toTransMap(order_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'logisticsVehicleInfo', params: { order_number: order_number } });
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
            this.getStatisData();
        },
        // 根据关键词搜索
        handleSearch() {
            this.page.pageindex = 1;
            this.orderList = [];
            this.finished = false;
            this.orderListPage();
            this.getStatisData();
        },
        // 分页拉取
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.orderListPage();
        },
        // 订单进度分页
        async orderListPage() {
            const res = await this.BLL.getOrderList();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
        // 展开筛选菜单
        showPopup() {
            this.popupShow = true;
        },
        // 选择筛选条件 状态
        handleSelectStatus(item) {
            this.selectStatus = item.val;
        },
        // 选择筛选条件 场站
        handleSelectStation(item) {
            this.selectStationCode = item.station_id;
            this.selectStationName = item.name;
        },
        confirmSelect() {
            this.status = this.selectStatus;
            this.station_code = this.selectStationCode;
            this.station_name = this.selectStationName;
            this.popupShow = false;
            this.handleSearch();
        },
        resetSelect() {
            this.selectStatus = '';
            this.selectStationCode = '';
            this.selectStationName = '';
        },
        // 获取统计数据
        async getStatisData() {
            this.$axios.get('/interfaceApi/production/producttask/get_order_progress_statistics?station_code=' + this.station_code)
                .then(data => {
                    this.quantityTotal = data.quantityTotal;
                    this.volumeTotal = data.volumeTotal;
                });
        },
        // 获取场站数据
        async getStationData() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationLs.push(...stationList);
            }
        },

    },

};
</script>

<style lang="stylus">
.orderSituationList
    height 100%
    background #F0F0F0
    .count-box
        position relative
        width 100%;
        padding 6rpx 15rpx 6rpx;
        .title
            font-size 12rpx;
            color #333;
        .count-item
            display flex
            justify-content space-between
            margin-top 3rpx;
            .item
                box-sizing border-box
                width: 165rpx;
                height: 32rpx;
                background: linear-gradient(309deg, #EFAB54 0%, #FA8C47 100%);
                display flex;
                align-items center;
                color #FFFFFF
                font-size 12rpx;
                padding-left 10rpx;
                white-space nowrap
                label
                    font-size 21rpx;
            .item2
                background: linear-gradient(132deg, #48A0D8 0%, #7FD0FE 100%);
    .van-pull-refresh
        height calc(100% - 150rpx)
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        .warpper
            .list
                .state
                    // 未审批
                    &.status0
                        background #0189FC
                    // 审批中
                    &.status1
                        background #FF6600
                    // 转换中
                    &.status2
                        background #0101B5
                    // 变更中
                    &.status3
                        background #04A2B9
                    // 正常供应
                    &.status10
                        background #04B97F
                    // 暂停供应
                    &.status20
                        background #979EA7
                    // 完成供应
                    &.status30
                        background #04B97F
                    // 完成供应
                    &.status40
                        background #E60000
    .sideslip
        .screen
            height 100%;
            position relative;
            .van-nav-bar__content
                background #fff;
            /deep/ .van-nav-bar__content
                background #fff;
            section
                border-top 15rpx solid #F0F0F0;
                padding 15rpx;
                overflow scroll
                -webkit-overflow-scrolling touch
                .item
                    padding-top 15rpx;
                    .title
                        padding-left 2rpx;
                        font-size 14rpx;
                        color #333;
                    ul
                        display flex
                        flex-wrap wrap
                        padding 8rpx 0;
                        li
                            padding 7rpx 0;
                            width: 80rpx;
                            height: 30rpx;
                            border-radius: 4rpx;
                            display flex
                            justify-content center
                            align-items center
                            margin 5rpx;
                            font-size 14rpx;
                            color #666666
                            background #F1F1F1
                            &.active
                                background #FEE5E5
                                color #E60000
            footer
                width 100%;
                position absolute;
                left 0;
                bottom 0;
                display: flex;
                flex-direction: row-reverse;
</style>
